import { useIntl } from 'react-intl'
import { useDrawerState } from '../../../Drawer'
import { useConditions } from '../useConditions'
import { messages } from './messages'
import { IconUser } from '@vtex/admin-ui'
import type { FirstPurchase as FirstPurchaseType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useWatch } from '@vtex/admin-ui-form'
import { FirstPurchaseEditor } from './Editor'
import { FirstPurchaseView } from './View'

interface Props {
  name: string
}

export function FirstPurchase(props: Props) {
  const { name } = props
  const { $t } = useIntl()

  const { form } = useFormStateContext()

  const config: FirstPurchaseType | undefined = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.title),
    icon: <IconUser />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: FirstPurchaseType | undefined) =>
    form.setValue(name, values)

  return (
    <>
      <FirstPurchaseView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <FirstPurchaseEditor
        state={editorState}
        initialConfig={config}
        onSave={handleSave}
      />
    </>
  )
}
